const development_tenant = {
    notification: 'Ви перебуваєте в режимі розробки',
};
export default Object.freeze(development_tenant);
